import React from 'react';

export const GetHelp = () => (
  <>
    <p>
      <strong>If you have trouble using this online form</strong>, call us at{' '}
      <va-telephone contact="8006982411" /> (<va-telephone contact="711" tty />
      ). We’re here 24/7.
    </p>

    <p>
      <strong>
        If you need help gathering your information or filling out your form
      </strong>
      , contact a local Veterans Service Organization (VSO).
    </p>

    <p>
      <a href="https://www.va.gov/get-help-from-accredited-representative/find-rep/">
        Find a local Veterans Service Organization
      </a>
    </p>
  </>
);
